import { Directive, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';
import { toUniversalDateString } from '@assetaccountant/core';

/**
 * Based off: https://github.com/angular/angular/blob/master/packages/forms/src/directives/validators.ts
 */

@Directive({
  selector:
    // eslint-disable-next-line @angular-eslint/directive-selector
    '[maxDate][formControlName],[maxDate][formControl],[maxDate][ngModel]:not([ngbDatepicker])',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MaxDateValidator),
      multi: true,
    },
  ],
  standalone: false,
})
export class MaxDateValidator implements Validator, OnChanges {
  private _validator: ValidatorFn | null = null;
  private _onChange?: () => void;

  @Input() maxDate: string | null | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if ('maxDate' in changes) {
      this._createValidator();
      if (this._onChange) {
        this._onChange();
      }
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this._validator && this._validator(control);
  }

  registerOnValidatorChange(fn: () => void): void {
    this._onChange = fn;
  }

  private _createValidator(): void {
    const maxDate = toUniversalDateString(this.maxDate);
    if (maxDate) {
      this._validator = control => {
        if (!control) {
          return null;
        }
        const controlValue = toUniversalDateString(control.value);
        if (!controlValue) {
          return null;
        }
        return controlValue <= maxDate
          ? null
          : {
              maxDate: {
                maxDate,
                actualDate: control.value,
              },
            };
      };
    } else {
      this._validator = null;
    }
  }
}
